<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
            placeholder="代理商"
            ref="myCascader"
            :options="agentTree"
            :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userId"
            @change="search"
            filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="isShow">
        <el-select v-model="queryParams.isShow" filterable clearable placeholder="是否上架" @change="search">
          <el-option v-for="item in isshow" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addItem">添加</el-button>
      </el-form-item>
    </el-form>
    <div class="table">
      <el-table :data="tableData" border id="out-table" style="width: 100%">
        <el-table-column prop="ids" label="序号" align="center" width="60"></el-table-column>
        <el-table-column prop="company" label="代理商" align="center" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="资费套餐" align="center" min-width="130">
          <template slot-scope="scope">
            <template v-if="showProductSort" >
              <div v-if="showAdmin" class="cell-ellipsis" :title="'【'+scope.row.productId+'】'+scope.row.productName">【{{scope.row.productId}}】{{scope.row.productName}}</div>
              <div v-else class="cell-ellipsis" :title="scope.row.productName">{{scope.row.productName}}</div>
              <div class="cell-ellipsis"><span class="cell-label">H5名称：</span>{{scope.row.h5ProductName}}</div>
            </template>
            <template v-else>
              <div class="cell-ellipsis">{{scope.row.h5ProductName}}</div>
            </template>
            <div class="package-type" v-if="showAdmin">
              <el-tag v-if="scope.row.type == '1'" size="mini" type="primary">流量套餐</el-tag>
              <el-tag v-if="scope.row.type == '2'" size="mini" type="success">短信套餐</el-tag>
              <el-tag v-if="scope.row.type == '3'" size="mini" type="warning">国际套餐</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="简介" align="center" min-width="70">
          <template slot-scope="{row}">
            <div class="product-list">
              <div class="product-item" v-for="(item,index) in row.unitProducts" :key="index" 
                    :title="'【'+item.countryName+'】' + item.operationName+'：' +'底价('+ item.currencySymbol + item.basePrice +')'+' 售价('+item.currencySymbol + item.price +')'+' 市场价('+item.currencySymbol + item.marketPrice +')'">
                <span class="item-title">{{item.operationName}}</span>
                <span class="item-price">底价 {{item.currencySymbol}}{{item.basePrice}}</span>
                <span class="item-price">售价 {{item.currencySymbol}}{{item.price}}</span>
                <!-- <span class="item-price" v-if="item.marketPrice>0">市场价 {{item.currencySymbol}}{{item.marketPrice}}</span> -->
                <i v-if="showAdmin" class="el-icon-delete del-operator" @click="handleDeleteOperator(row, item, index)" title="删除该运营商"></i>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="H5展示顺序" align="center" width="110" v-if="showProductSort">
          <template slot="header">
              <el-tooltip content="数字越小，H5展示顺序越靠前" placement="top">
                  <i class="el-icon-question"></i>
              </el-tooltip>
              H5展示顺序
          </template>
          <template slot-scope="{row}">
            <el-input-number
              v-model="row.sortNum"
              size="mini"
              :controls="false"
              :min="0"
              :max="999999"
              :precision="0"
              placeholder="排序"
              class="sort-input"
              @change="handleSortChange(row)"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="isShow" label="是否上架" align="center" width="100">
          <template slot-scope="{row}">
            <el-tag v-if="row.isShow == '1'" size="mini">已上架</el-tag>
            <el-tag v-if="row.isShow == '0'" type="danger" size="mini">未上架</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="{row}">
            <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="handleEdit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="queryInfo"
    />
    <div>
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="60%" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="propsParams" :rules="ruleValidate" ref="propsParams">
        <el-form-item label="代理商:" prop="userId" :label-width="LabelWidth" >
          <el-cascader style="width: 100%"
              v-show="!useridDisabled"
              placeholder="代理商"
              ref="myCascader"
              :options="agentTree"
              :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
              :show-all-levels="false"
              clearable
              v-model="propsParams.userId"
              filterable></el-cascader>
          <el-input v-show="useridDisabled" v-model="propsParams.company" disabled  style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="资费套餐:" prop="productId" :label-width="LabelWidth">
          <el-select v-model="propsParams.productId" filterable placeholder="请选择资费套餐" style="width: 100%" @change="selectedPackage()" :disabled='serveridDisabled'>
            <el-option v-for="item in optPackage" :key="item.id" :label="item.id +'-'+item.productName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showProductSort" label="套餐名称:" prop="productName" :label-width="LabelWidth">
          <el-input v-model="propsParams.productName" placeholder="请输入H5展示名称" style="width: 100%"></el-input>
        </el-form-item>
        <el-row v-if="!propsParams.ltDeleted" type="flex" align="middle" class="operator-row">
          <el-col :span="11">
            <el-form-item  label="联通底价:" prop="ltBasePrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.ltBasePrice" autocomplete="off" style="width: 100%"  placeholder="请输入联通底价" 
              :disabled='ltBasePriceDisabled'
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                <template slot="prepend" v-if="!ltBasePriceDisabled">>={{baseForm.ltBasePrice}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联通售价:" prop="ltPrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.ltPrice" autocomplete="off" style="width: 100%"
              placeholder="请输入联通售价"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend">>={{propsParams.ltBasePrice || 0}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="row-delete" v-if="showAdmin">
            <i class="el-icon-delete" @click="handleDeleteRow('lt')" title="删除联通"></i>
          </el-col>
        </el-row>
        <el-row v-if="showAdmin &&propsParams.ltDeleted" class="restore-row">
          <el-col :span="24">
            <el-button type="text" icon="el-icon-plus" @click="handleRestoreRow('lt')" class="restore-btn">添加联通</el-button>
          </el-col>
        </el-row>
        <el-row v-if="!propsParams.dxDeleted" type="flex" align="middle" class="operator-row">
          <el-col :span="11">
            <el-form-item  label="电信底价:" prop="dxBasePrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.dxBasePrice" autocomplete="off" style="width: 100%" 
              placeholder="请输入电信底价" 
              :disabled='dxBasePriceDisabled'
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend" v-if="!dxBasePriceDisabled">>={{baseForm.dxBasePrice}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="电信售价:" prop="dxPrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.dxPrice" autocomplete="off" style="width: 100%" 
              placeholder="请输入电信售价"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend">>={{propsParams.dxBasePrice || 0}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="row-delete" v-if="showAdmin">
            <i class="el-icon-delete" @click="handleDeleteRow('dx')" title="删除电信"></i>
          </el-col>
        </el-row>
        <el-row v-if="showAdmin && propsParams.dxDeleted" class="restore-row">
          <el-col :span="24">
            <el-button type="text" icon="el-icon-plus" @click="handleRestoreRow('dx')" class="restore-btn">添加电信</el-button>
          </el-col>
        </el-row>
        <el-row v-if="!propsParams.ydDeleted" type="flex" align="middle" class="operator-row">
          <el-col :span="11">
            <el-form-item  label="移动底价:" prop="ydBasePrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.ydBasePrice" autocomplete="off" style="width: 100%" 
              placeholder="请输入移动底价" 
              :disabled='ydBasePriceDisabled'
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend" v-if="!ydBasePriceDisabled">>={{baseForm.ydBasePrice}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="移动售价:" prop="ydPrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.ydPrice" autocomplete="off" style="width: 100%" 
              placeholder="请输入移动售价"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend">>={{propsParams.ydBasePrice || 0}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="row-delete" v-if="showAdmin">
            <i class="el-icon-delete" @click="handleDeleteRow('yd')" title="删除移动"></i>
          </el-col>
        </el-row>
        <el-row v-if="showAdmin && propsParams.ydDeleted" class="restore-row">
          <el-col :span="24">
            <el-button type="text" icon="el-icon-plus" @click="handleRestoreRow('yd')" class="restore-btn">添加移动</el-button>
          </el-col>
        </el-row>
        <el-form-item label="市场价格:" prop="marketPrice" :label-width="LabelWidth" v-if="showAdmin">
          <el-input v-model="propsParams.marketPrice" autocomplete="off" style="width: 100%" 
          placeholder="请输入市场价格"
          oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="是否上架:" prop="isShow" :label-width="LabelWidth">
        <el-switch
          v-model="propsParams.isShow"
          active-color="#13ce66"
          inactive-color="#DCDFE6"
          active-value="1"
          inactive-value="0"
        ></el-switch>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog">取消</el-button>
        <el-button type="success" @click="saveDialog">确认</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import {agentTreeList} from "@/api/api.js"; //新建套餐代理商
import { addBaseProduct } from "@/api/api.js"; //新建低价套餐
import { updateBaseProduct } from "@/api/api.js"; //编辑低价套餐 updateBaseProduct
import { selectProductList } from "@/api/api.js"; //资费套餐下拉01
import { baseProductPage } from "@/api/api.js"; //获取列表
import { baseProductInfo } from "@/api/api.js"; //编辑获取详情
import { getParentBaseProductInfo , deleteBaseProductOperator , updateBaseProductSort} from "@/api/api.js"; //底价套餐选择套餐id 出现对应的数据 / H5排序保存
export default {
  name: "proxy",
  data() {
    return {
      useridDisabled:false,//代理商
      serveridDisabled:false,//资费套餐
      ltBasePriceDisabled:false,//底价
      dxBasePriceDisabled:false,//底价
      ydBasePriceDisabled:false,//底价
      showUpOrDownProduct:false,
      queryParams: {
        userId:undefined,
        isShow:undefined
      },
      tableData: [],
      // 分页器
      page: 1,
      pageSize: 20,
      total: 20,
      // 代理商
      agentTree: [],
      optPackage: [],
      level:'',
      title: "创建代理商资费",
      // 弹窗
      dialog: false,
      LabelWidth: "120px",
      propsParams: {
        productName:'',
        ltBasePrice:'',
        dxBasePrice:'',
        ydBasePrice:'',
        ltPrice:'',
        dxPrice:'',
        ydPrice:'',
        marketPrice:'',
        ltDeleted:false,
        dxDeleted:false,
        ydDeleted:false,
        userId:undefined,
        productId:undefined,
        isShow:'1',
        ltOriginalBasePrice: 0,
        ltOriginalPrice: 0,
        dxOriginalBasePrice: 0,
        dxOriginalPrice: 0,
        ydOriginalBasePrice: 0,
        ydOriginalPrice: 0,
      },
      //基础
      baseForm:{
        ltBasePrice:0,
        dxBasePrice:0,
        ydBasePrice:0,
        ltOriginalBasePrice:0,
        dxOriginalBasePrice:0,
        ydOriginalBasePrice:0,
      },
      isshow:[
        {
          value: 0,
          label: "未上架"
        },
        {
          value: 1,
          label: "已上架"
        },
      ],
      baseId:null
    };
  },
  computed: {
    showAdmin(){
        return this.$store.getters.user.userType =='1'; 
    },
    showProductSort(){
        if(this.$store.getters.user.userType =='1'){
            return true;
        }
        return this.$store.getters.user.level =='1';
    },
    ruleValidate() {
      var checkLtBasePrice = (rule, value, callback) => {
        if (value === '' || value === null || value === undefined) {
          return callback();
        }
        if (Number(value)<this.baseForm.ltBasePrice) {
          return callback(new Error('联通底价必须大于等于' + this.baseForm.ltBasePrice +"元"));
        }
        callback();
      };
      var checkDxBasePrice = (rule, value, callback) => {
        if (value === '' || value === null || value === undefined) {
          return callback();
        }
        if (Number(value)<this.baseForm.dxBasePrice) {
          return callback(new Error('电信底价必须大于等于' + this.baseForm.dxBasePrice +"元"));
        }
        callback();
      };
      var checkYdBasePrice = (rule, value, callback) => {
        if (value === '' || value === null || value === undefined) {
          return callback();
        }
        if (Number(value)<this.baseForm.ydBasePrice) {
          return callback(new Error('移动底价必须大于等于' + this.baseForm.ydBasePrice +"元"));
        }
        callback();
      };
      var checkLtPrice = (rule, value, callback) => {
        if (value === '' || value === null || value === undefined) {
          return callback();
        }
        if (!this.propsParams.ltBasePrice || Number(value)<Number(this.propsParams.ltBasePrice)) {
          return callback(new Error('联通售价必须大于等于' + this.propsParams.ltBasePrice +"元"));
        }
        callback();
      };
      var checkDxPrice = (rule, value, callback) => {
        if (value === '' || value === null || value === undefined) {
          return callback();
        }
        if (!this.propsParams.dxBasePrice || Number(value)<Number(this.propsParams.dxBasePrice)) {
          return callback(new Error('电信售价必须大于等于' + this.propsParams.dxBasePrice +"元"));
        }
        callback();
      };
      var checkYdPrice = (rule, value, callback) => {
        if (value === '' || value === null || value === undefined) {
          return callback();
        }
        if (!this.propsParams.ydBasePrice || Number(value)<Number(this.propsParams.ydBasePrice)) {
          return callback(new Error('移动售价必须大于等于' + this.propsParams.ydBasePrice +"元"));
        }
        callback();
      };
      const rules = {
        userId: [
          { required: true, message: "公司名", trigger: "blur" }
        ],
        productId: [
          { required: true, message: "请选择资费套餐", trigger: "blur" }
        ],
        productName: [
          { required: true, message: "请输入H5展示名称", trigger: "blur" }
        ],
      };
      if(!this.propsParams.ltDeleted){
        rules.ltBasePrice = [
          { required: true, message: "请输入联通底价", trigger: "blur" },
          { validator: checkLtBasePrice, trigger: 'blur' }
        ];
        rules.ltPrice = [
          { required: true, message: "请输入联通售价", trigger: "blur" },
          { validator: checkLtPrice, trigger: 'blur' }
        ];
      }
      if(!this.propsParams.dxDeleted){
        rules.dxBasePrice = [
          { required: true, message: "请输入电信底价", trigger: "blur" },
          { validator: checkDxBasePrice, trigger: 'blur' }
        ];
        rules.dxPrice = [
          { required: true, message: "请输入电信售价", trigger: "blur" },
          { validator: checkDxPrice, trigger: 'blur' }
        ];
      }
      if(!this.propsParams.ydDeleted){
        rules.ydBasePrice = [
          { required: true, message: "请输入移动底价", trigger: "blur" },
          { validator: checkYdBasePrice, trigger: 'blur' }
        ];
        rules.ydPrice = [
          { required: true, message: "请输入移动售价", trigger: "blur" },
          { validator: checkYdPrice, trigger: 'blur' }
        ];
      }
      return rules;
    }
  },
  methods: {
    updateShow(show){
      this.queryInfo()
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList({self:'1'}).then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 资费套餐下拉
    queryServerList() {
      selectProductList({}).then(res => {
        this.optPackage = res.data.data;
        if(!!this.optPackage){
          this.optPackage = this.optPackage.filter(item=> (item.type=='1' ||  item.type=='2'));
        }
        
      });
    },
    // 获取列表
    queryInfo() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      baseProductPage(params).then(res => {
        if (res.data.code == 200) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.records || [];
          this.tableData.forEach((item,index)=>{
            this.$set(item, 'ids', index + 1);
            // 兼容后端返回 sortNum（驼峰）或 sort_num（下划线）
            const sortVal = (item.sortNum === null || item.sortNum === undefined) ? item.sort_num : item.sortNum;
            this.$set(item, 'sortNum', (sortVal === null || sortVal === undefined) ? 0 : Number(sortVal));
            // 记住初始值，用于「值未变不发请求」和保存失败回滚
            this.$set(item, 'originSortNum', item.sortNum);
          })
        }else{
          this.$message.error(res.data.message)
        }
      });
    },
    // 搜索
    search() {
      this.page = 1,
      this.queryInfo();
    },
    // H5排序：输入后失焦/回车即保存
    handleSortChange(row) {
      const val = (row.sortNum === null || row.sortNum === undefined || row.sortNum === '') ? 0 : Number(row.sortNum);
      row.sortNum = val;
      // 值没变就不请求
      if (val === row.originSortNum) return;
      if (row.sortSaving) return;
      this.$set(row, 'sortSaving', true);
      updateBaseProductSort({ id: row.id, sortNum: val }).then(res => {
        if (res.data.code == 200) {
          this.$message.success('排序已保存');
          row.originSortNum = val;
        } else {
          this.$message.error(res.data.message);
          this.$set(row, 'sortNum', row.originSortNum); // 失败回滚
        }
      }).catch(() => {
        this.$set(row, 'sortNum', row.originSortNum);
      }).finally(() => {
        this.$set(row, 'sortSaving', false);
      });
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.queryInfo();
    },
    // 添加
    addItem() {
      this.dialog = true;
      this.title = "创建底价套餐";
      this.propsParams = {
        productName:'',
        ltBasePrice: '',
        dxBasePrice: '',
        ydBasePrice: '',
        ltPrice: '',
        dxPrice: '',
        ydPrice: '',
        marketPrice: '',
        ltDeleted: false,
        dxDeleted: false,
        ydDeleted: false,
        userId: undefined,
        productId: undefined,
        isShow: '1',
        ltOriginalBasePrice: 0,
        ltOriginalPrice: 0,
        dxOriginalBasePrice: 0,
        dxOriginalPrice: 0,
        ydOriginalBasePrice: 0,
        ydOriginalPrice: 0,
      };
      this.baseForm = {
        ltBasePrice: 0,
        dxBasePrice: 0,
        ydBasePrice: 0,
      };
      this.useridDisabled = false;
      this.serveridDisabled = false;
      this.ltBasePriceDisabled = false;
      this.dxBasePriceDisabled = false;
      this.ydBasePriceDisabled = false;
      this.showUpOrDownProduct = true;
      this.$nextTick(() => {
        this.$refs.propsParams && this.$refs.propsParams.clearValidate();
      });
    },
    // 确定保存
    saveDialog() {
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          let params = {
            ...this.propsParams,
          };
          if(this.title == "创建底价套餐"){
            addBaseProduct(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("创建底价套餐成功");
                this.dialog = false;
                this.page = 1; // 新建的排在最前面，回到第一页才看得到
                this.queryInfo();
              }else{
                this.$message.error(res.data.message);
              }
            })
          }else{
            updateBaseProduct(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("编辑底价套餐成功");
                this.dialog = false;
                this.queryInfo();
                this.queryServerList();
              }else{
                this.$message.error(res.data.message);
              }
            })
          }
        }
      })
    },
    // 修改
    handleEdit(row) {
      if(row.type=='3'){
        this.baseId = row.id
        return
      }
      this.title = "编辑底价套餐";
      this.dialog = true;
      this.useridDisabled = true;
      this.serveridDisabled = true;
      // this.propsParams.ltDeleted = false;
      // this.propsParams.dxDeleted = false;
      // this.propsParams.ydDeleted = false;
      if(this.showAdmin){
          this.showUpOrDownProduct = true;
      }
      if(!this.showAdmin){
        this.ltBasePriceDisabled = true;
        this.dxBasePriceDisabled = true;
        this.ydBasePriceDisabled = true;
        //控制显示下架按钮 自己建的可以控制上下架
        this.showUpOrDownProduct = false;
        let userId = this.$store.getters.user.userId;
        if(row.userId != userId){
          this.ltBasePriceDisabled = false;
          this.dxBasePriceDisabled = false;
          this.ydBasePriceDisabled = false;
          this.showUpOrDownProduct = true;
        }
      }
      let params = {
        id: row.id
      };
      baseProductInfo(params).then(res => {
        if (res.data.code == 200) {
          this.propsParams = Object.assign({}, res.data.data);
          this.baseForm.dxBasePrice = res.data.data.supDxBasePrice;
          this.baseForm.ltBasePrice = res.data.data.supLtBasePrice;
          this.baseForm.ydBasePrice = res.data.data.supYdBasePrice;
          // 备份运营商原始价格，便于删除后重新添加时恢复
          this.$set(this.propsParams, 'ltOriginalBasePrice', res.data.data.ltBasePrice || 0);
          this.$set(this.propsParams, 'ltOriginalPrice', res.data.data.ltPrice || 0);
          this.$set(this.propsParams, 'dxOriginalBasePrice', res.data.data.dxBasePrice || 0);
          this.$set(this.propsParams, 'dxOriginalPrice', res.data.data.dxPrice || 0);
          this.$set(this.propsParams, 'ydOriginalBasePrice', res.data.data.ydBasePrice || 0);
          this.$set(this.propsParams, 'ydOriginalPrice', res.data.data.ydPrice || 0);

          this.$set(this.baseForm, 'ltOriginalBasePrice', res.data.data.supLtBasePrice || 0);
          this.$set(this.baseForm, 'dxOriginalBasePrice', res.data.data.supDxBasePrice || 0);
          this.$set(this.baseForm, 'ydOriginalBasePrice', res.data.data.supYdBasePrice || 0);
          this.$nextTick(() => {
            this.$refs.propsParams && this.$refs.propsParams.clearValidate();
          });
        }
      })
    },
    cancelDialog() {
      this.dialog = false;
    },
    // 删除单个运营商
    handleDeleteOperator(row, item, index) {
      this.$confirm('确认删除【' + item.countryName + '】' + item.operationName + ' 的价格配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(item)
        let params = {
          operatorName: item.operationName,
          userId: row.userId,
          productId: row.productId
        };
        deleteBaseProductOperator(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('删除成功');
            this.queryInfo();
          }else{
            this.$message.error(res.data.message);
          }
        })
      }).catch(() => {});
    },
    // 删除弹窗内某一行运营商
    handleDeleteRow(type){
      const nameMap = { lt: '联通', dx: '电信', yd: '移动' };
      this.$confirm('确认删除【' + nameMap[type] + '】的价格配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$set(this.propsParams, type + 'Deleted', true);
        this.$set(this.propsParams, type + 'BasePrice', 0);
        this.$set(this.propsParams, type + 'Price', 0);
        this.$message.success('已删除');
      }).catch(() => {});
    },
    // 恢复被删除的某一行运营商
    handleRestoreRow(type){
      this.$set(this.propsParams, type + 'Deleted', false);
      // 从初次加载的原始数据恢复该运营商的底价/售价
      this.$set(this.propsParams, type + 'BasePrice', this.propsParams[type + 'OriginalBasePrice'] || 0);
      this.$set(this.baseForm, type + 'BasePrice', this.baseForm[type + 'OriginalBasePrice'] || 0);
      this.$set(this.propsParams, type + 'Price', this.propsParams[type + 'OriginalPrice'] || 0);
      this.$nextTick(() => {
        this.$refs.propsParams.clearValidate([type + 'BasePrice', type + 'Price']);
      });
    },
    // 关闭弹窗
    dialogClose() {
      this.$refs.propsParams.clearValidate();
      this.baseForm ={
        ltBasePrice:0,
        dxBasePrice:0,
        ydBasePrice:0
      };
      this.propsParams = {
        productName:'',
        ltBasePrice:'',
        dxBasePrice:'',
        ydBasePrice:'',
        ltPrice:'',
        dxPrice:'',
        ydPrice:'',
        marketPrice:'',
        ltDeleted: false,
        dxDeleted: false,
        ydDeleted: false,
        userId: undefined,
        productId: undefined,
        isShow: '1',
        ltOriginalBasePrice: 0,
        ltOriginalPrice: 0,
        dxOriginalBasePrice: 0,
        dxOriginalPrice: 0,
        ydOriginalBasePrice: 0,
        ydOriginalPrice: 0,
      };
      this.dialog = false;
    },

    // 套餐选中
    selectedPackage(){
      // 切换套餐时恢复已删除的运营商行
      this.propsParams.ltDeleted = false;
      this.propsParams.dxDeleted = false;
      this.propsParams.ydDeleted = false;
      // 切换套餐时自动填充H5展示名称
      const pkg = this.optPackage.find(item => item.id === this.propsParams.productId);
      if (pkg && pkg.productName) {
        this.propsParams.productName = pkg.productName;
      }
      if(!this.showAdmin){
        let params = {
          productId:this.propsParams.productId,
          userId:this.propsParams.userId
        };
        getParentBaseProductInfo(params).then(res=>{
          this.$set(this.propsParams,'productName', res.data.data.productName);
          this.$set(this.propsParams,'ltDeleted',res.data.data.ltDeleted);
          this.$set(this.propsParams,'dxDeleted',res.data.data.dxDeleted);
          this.$set(this.propsParams,'ydDeleted',res.data.data.ydDeleted);

          this.$set(this.propsParams,'ltBasePrice',res.data.data.ltBasePrice);
          this.$set(this.propsParams,'dxBasePrice',res.data.data.dxBasePrice);
          this.$set(this.propsParams,'ydBasePrice',res.data.data.ydBasePrice);
          this.$set(this.propsParams,'ltPrice',res.data.data.ltPrice);
          this.$set(this.propsParams,'dxPrice',res.data.data.dxPrice);
          this.$set(this.propsParams,'ydPrice',res.data.data.ydPrice );
          this.$set(this.propsParams,'marketPrice',res.data.data.marketPrice);

          this.baseForm.ltBasePrice = res.data.data.ltBasePrice;
          this.baseForm.dxBasePrice = res.data.data.dxBasePrice;
          this.baseForm.ydBasePrice = res.data.data.ydBasePrice;
        })
      }
    }
  },
  mounted() {
    this.queryInfo();
    this.queryServerList();
    this.handleAgentTreeList();
  }
};
</script>
<style scoped lang="less">
.sort-input{
  width: 88px;
  /deep/ .el-input__inner{
    text-align: center;
    padding-left: 4px;
    padding-right: 4px;
  }
}
.cell-ellipsis{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
// 单元格内"标签："与值的颜色区分
.cell-label{
  color: #909399;
}
.package-type{
  margin-top: 6px;
}
.product-list{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  color: #409eff;
  .product-item{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    white-space: nowrap;
    padding: 4px 8px;
    background: #ecf5ff;
    border: 1px solid #b3d8ff;
    border-radius: 4px;
    font-size: 12px;
    line-height: 1.5;
    box-sizing: border-box;
    .item-title{
      font-weight: 500;
      margin-right: 8px;
      white-space: nowrap;
    }
    .item-price{
      margin-right: 8px;
      color: #606266;
      white-space: nowrap;
    }
    .del-operator{
      margin-left: 6px;
      color: #f56c6c;
      cursor: pointer;
      font-size: 14px;
      &:hover{
        color: #d9363e;
      }
    }
  }
}
.operator-row{
  display: flex;
  .row-delete{
    display: flex;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    min-height: 40px;
    i{
      color: #f56c6c;
      cursor: pointer;
      font-size: 16px;
      &:hover{
        color: #d9363e;
      }
    }
  }
}
.restore-row{
  margin-bottom: 12px;
  .restore-btn{
    padding: 4px 8px;
    font-size: 13px;
    color: #409eff;
  }
}
</style>